import * as angular from 'angular';

import { BadActorsWidgetBase, IBadActorsWidgetOptions } from './badActorsWidgetBase';
import { IWidgetConfiguration } from '..//models';
import { calculatedDefaultState } from '../../common/';
import { IInputValuesService } from '../../services';

export class BadActorsSuspiciousPrecedentsWidget extends BadActorsWidgetBase {
    configuration: any;
    highlights = ['A bar chart of precedents of suspicious KPIs'];
    name = 'Precedents of suspicious KPIs - Most frequent issues';
    options: IBadActorsWidgetOptions;
    type = 'badActorsSuspiciousPrecedents';

    constructor(
        private _$state: angular.ui.IStateService,
        private _inputValuesService: IInputValuesService,
        config?: IWidgetConfiguration
    ) {
        super(config);
        this.options = {
            seriesClick: (d, i) => {
                this._$state.go(calculatedDefaultState, { identifierGuid: d.guid });
            }
        };
        this.configuration = {
            labels: []
        };
    }

    readData(guid?: string): angular.IPromise<any> {
        return this._inputValuesService.getNumberOfSuspiciousPrecedents(guid);
    }
}